<template>
    <div class="universe-list">
        <gcmcn-filters
            ref="gcmcn-filters"
            :filter-values="[selectedSortType, searchFilter, selectedEntitiesForFilter]"
            @reset-filters="resetFilters"
            @hook:mounted="computeFilterHeight"
        >
            <dropdown
                name="Sort"
                :multiple="false"
                :list="sortTypeList"
                itemName="name"
                itemValue="value"
                :itemsSelected="selectedSortType.length > 0 ? [selectedSortType] : []"
                @on-select-item="selectedSortType = $event"
            ></dropdown>
            <dropdown
                name="Entities"
                :multiple="true"
                :list="$store.getters.entities"
                itemName="display_name"
                itemValue="uid"
                :itemsSelected="selectedEntitiesForFilter"
                @on-select-item="onSelectEntities"
            ></dropdown>
            <search-filter ref="search" @new-value="searchFilter = $event"></search-filter>
        </gcmcn-filters>
        <div
            v-if="filteredUniverses.length > 0"
            class="universes-container"
            :style="{height: `calc(100vh - ( ${usedHeight}px)`}"
        >
            <universeCard
                v-for="universe in filteredUniverses"
                :key="universe.uid"
                :universe="universe"
                :selected-universe="selectedUniverse"
                @on-universe-selected="setSelectedUniverse"
            ></universeCard>
        </div>
        <div v-else class="list-empty">No universes</div>
    </div>
</template>

<script>

import universeCard from './universeCard.vue';
import {
    GcmcnFilters,
    Dropdown,
    SearchFilter ,
} from 'gcmcn-common';
import { mapGetters } from 'vuex';

export default {

    components: {
        universeCard,
        GcmcnFilters,
        Dropdown,
        SearchFilter,
    },
    props: {
        universes: {
            type: Array,
            required: true,
        },
        selectedUniverse: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        },
    },
    data: function(){
        return {
            sortTypeList: [{name: 'asc', value:'asc'}, {name: 'dsc', value:'dsc'}],
            selectedSortType: 'asc',
            searchFilter: '',
            usedHeight: 0
        };
    },

    computed: {
        ...mapGetters(['selectedEntitiesForFilter']),
        filteredUniverses (){
            let universes = this.universes.slice();
            if(this.selectedSortType){
                universes.sort((a, b) => a.display_name.localeCompare(b.display_name));
                if(this.selectedSortType === 'dsc'){
                    universes.reverse();
                }
            }
            if(this.searchFilter){
                universes = universes.filter((u) => u.display_name.toLowerCase().includes(this.searchFilter.toLowerCase()));
            }
            if(this.selectedEntitiesForFilter.length > 0){
                universes = universes.filter((u) => this.selectedEntitiesForFilter.includes(u.scopes.entity_uid));
            }
            return universes;
        },
    },
    watch: {
        windowWidth (){
            this.computeFilterHeight();
        },
    },
    mounted (){
        this.computeFilterHeight();
    },
    methods: {
        computeFilterHeight() {
            if(this.$refs['gcmcn-filters']){
                const clientRect = this.$refs['gcmcn-filters'].$el.getBoundingClientRect();
                this.usedHeight = clientRect.top + clientRect.height + 10 + 32; // +10 par ce que l'element contient un margin, et les margin ne sont pas comptés dans la height d'un element
                // 32 -> on enleve la height du wrapper d'alerte de fundation
            }
        },
        onSelectEntities (entities) {
            this.$store.commit('SET_ENTITIES_FOR_FILTER', entities);
        },
        resetFilters (){
            this.selectedSortType = '';
            this.$refs.search.clear();
            this.$store.commit('CLEAR_ALL_FILTERS');
        },
        setSelectedUniverse (universeUid){
            this.$emit('on-universe-selected', universeUid);
        }
    },
};
</script>

<style lang="scss">
.universe-list {
    .column-title {
        color: #AAA;
    }
    .universes-container {
        overflow-y: scroll;
        padding-right: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Universes/universeList.vue